import { useTranslation } from "react-i18next";

export const OrderTipInfo = () => {
	const { t } = useTranslation();

	return (
		<span className="order-tips-info">
			{`${t("modules.e_order.field.by_making_a_payment_you_accept.title")} `}
			<a href="https://www.gopos.pl/tos">{t("lib:go_security.register.words.tos")}</a> {`${t("common.word.or")} `}
			<a href="https://www.gopos.pl/privacy-policy">{t("lib:go_security.layout.footer.words.rules")}</a>
		</span>
	);
};
